import React from 'react'
import ReactDOM from 'react-dom'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage } from 'react-intl'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import { BigButton } from '../../../../../../components/button'
import BottomToTop from '../../../../../../components/transitions/bottom-to-top'
import { BlackMask } from '../../../../../../components/mask'

const CheckoutConfirm = props => {
    useStyles(classes)
    const {onContinue, onGuest, onClose, loading} = props
    return <div className={classes.Container}>
        <div className={classes.Hd}>
            <span className={classes.Title}><FormattedMessage id="secure_checkout" defaultMessage="Secure Checkout" /></span>
            <Iconfont className={classes.Close} onClick={onClose}>&#xe7c9;</Iconfont>
        </div>
        <div className={classes.Bd}>
            <div className={classes.TitleButton}>
                <div className={classes.Title}>
                    <FormattedMessage id="create_account_more_discount" defaultMessage="Create a new account to get more discount"/>
                </div>
                <BigButton className={classes.Button} onClick={onContinue}>
                    <FormattedMessage id="continue_to_checkout" defaultMessage="Continue to Checkout" />
                </BigButton>
            </div>

            <div className={classes.TitleButton}>
                <div className={classes.Title}>
                    <FormattedMessage id="checkout_guest_with_email" defaultMessage="Checkout as a guest with your email" />
                </div>
                <BigButton loading={loading} className={classes.Button} outlined onClick={onGuest}>
                    <FormattedMessage id="guest_checkout" defaultMessage="Guest Checkout" />
                </BigButton>
            </div>
        </div>
    </div>
}


const WrappedEditor = props => {
    useStyles(classes)
    return <React.Fragment>
        <BottomToTop in={props.show} className={classes.CheckoutContainer}>
            <div>
                <CheckoutConfirm {...props} />
            </div>
        </BottomToTop>
        {props.show && <BlackMask onClick={props.onClose} />}
    </React.Fragment>
}


export default props => {

    if (typeof window === 'undefined')
        return null

    return ReactDOM.createPortal(
        <WrappedEditor {...props} />,
        document.getElementById('root')
    )
}